import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useAchievement } from '../../context/AchievementContext';
import { Trophy, Award, MapPin, Star, Settings, Edit, Camera } from 'lucide-react';
import Button from '../../components/ui/Button';
const Profile: React.FC = () => {
  const {
    user
  } = useAuth();
  const {
    badges,
    achievements,
    stamps,
    points,
    level
  } = useAchievement();
  const [activeTab, setActiveTab] = useState('achievements');
  return <div className="w-full max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1268">
      {/* Profile Header */}
      <div className="bg-gradient-to-r from-[#E84118] to-[#c83616] rounded-lg p-6 md:p-8 text-white mb-6 md:mb-8" data-id="element-1269">
        <div className="flex flex-col sm:flex-row items-center sm:items-start" data-id="element-1270">
          <div className="relative mb-4 sm:mb-0" data-id="element-1271">
            <div className="w-20 h-20 md:w-24 md:h-24 bg-white rounded-full flex items-center justify-center text-[#E84118] text-3xl font-bold" data-id="element-1272">
              {user?.name?.charAt(0) || 'T'}
            </div>
            <button className="absolute bottom-0 right-0 bg-white rounded-full p-1.5 shadow-md" data-id="element-1273">
              <Camera size={16} className="text-gray-600" data-id="element-1274" />
            </button>
          </div>
          <div className="sm:ml-6 text-center sm:text-left flex-1" data-id="element-1275">
            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center" data-id="element-1276">
              <h1 className="text-2xl md:text-3xl font-bold mb-1" data-id="element-1277">
                {user?.name || 'Terry Crews'}
              </h1>
              <button className="hidden sm:flex items-center text-white bg-white bg-opacity-20 rounded-full px-3 py-1 text-sm hover:bg-opacity-30 transition-colors" data-id="element-1278">
                <Edit size={14} className="mr-1" data-id="element-1279" />
                Edit Profile
              </button>
            </div>
            <p className="opacity-90 mb-2" data-id="element-1280">Level {level} Food Explorer</p>
            <div className="flex justify-center sm:justify-start items-center text-sm" data-id="element-1281">
              <div className="flex items-center mr-4" data-id="element-1282">
                <Trophy size={16} className="mr-1" data-id="element-1283" />
                <span data-id="element-1284">{points} points</span>
              </div>
              <div className="flex items-center" data-id="element-1285">
                <MapPin size={16} className="mr-1" data-id="element-1286" />
                <span data-id="element-1287">Singapore</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Stats Grid */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-6 mb-6 md:mb-8" data-id="element-1288">
        <div className="bg-white rounded-lg shadow-md p-4 md:p-5" data-id="element-1289">
          <div className="flex items-center justify-between mb-2" data-id="element-1290">
            <h3 className="font-medium text-sm md:text-base" data-id="element-1291">Points</h3>
            <Trophy className="text-[#E84118]" size={18} data-id="element-1292" />
          </div>
          <div className="text-2xl md:text-3xl font-bold" data-id="element-1293">{points}</div>
        </div>
        <div className="bg-white rounded-lg shadow-md p-4 md:p-5" data-id="element-1294">
          <div className="flex items-center justify-between mb-2" data-id="element-1295">
            <h3 className="font-medium text-sm md:text-base" data-id="element-1296">Badges</h3>
            <Award className="text-[#E84118]" size={18} data-id="element-1297" />
          </div>
          <div className="text-2xl md:text-3xl font-bold" data-id="element-1298">
            {badges.filter(b => b.unlocked).length}
          </div>
        </div>
        <div className="bg-white rounded-lg shadow-md p-4 md:p-5" data-id="element-1299">
          <div className="flex items-center justify-between mb-2" data-id="element-1300">
            <h3 className="font-medium text-sm md:text-base" data-id="element-1301">Stamps</h3>
            <MapPin className="text-[#E84118]" size={18} data-id="element-1302" />
          </div>
          <div className="text-2xl md:text-3xl font-bold" data-id="element-1303">{stamps.length}</div>
        </div>
        <div className="bg-white rounded-lg shadow-md p-4 md:p-5" data-id="element-1304">
          <div className="flex items-center justify-between mb-2" data-id="element-1305">
            <h3 className="font-medium text-sm md:text-base" data-id="element-1306">Level</h3>
            <Star className="text-[#E84118]" size={18} data-id="element-1307" />
          </div>
          <div className="text-2xl md:text-3xl font-bold" data-id="element-1308">{level}</div>
        </div>
      </div>
      {/* Tab Navigation */}
      <div className="bg-white rounded-lg shadow-md mb-6 overflow-hidden" data-id="element-1309">
        <div className="flex border-b border-gray-200" data-id="element-1310">
          <button className={`flex-1 py-3 px-4 text-center font-medium ${activeTab === 'achievements' ? 'text-[#E84118] border-b-2 border-[#E84118]' : 'text-gray-500'}`} onClick={() => setActiveTab('achievements')} data-id="element-1311">
            Achievements
          </button>
          <button className={`flex-1 py-3 px-4 text-center font-medium ${activeTab === 'activity' ? 'text-[#E84118] border-b-2 border-[#E84118]' : 'text-gray-500'}`} onClick={() => setActiveTab('activity')} data-id="element-1312">
            Recent Activity
          </button>
          <button className={`flex-1 py-3 px-4 text-center font-medium ${activeTab === 'settings' ? 'text-[#E84118] border-b-2 border-[#E84118]' : 'text-gray-500'}`} onClick={() => setActiveTab('settings')} data-id="element-1313">
            Settings
          </button>
        </div>
        {/* Tab Content */}
        <div className="p-5 md:p-6" data-id="element-1314">
          {activeTab === 'achievements' && <div className="space-y-4" data-id="element-1315">
              <h2 className="text-lg font-bold mb-4" data-id="element-1316">Your Progress</h2>
              {achievements.map(achievement => <div key={achievement.id} className="border rounded-lg p-4" data-id="element-1317">
                  <div className="flex justify-between items-center mb-2" data-id="element-1318">
                    <h3 className="font-medium" data-id="element-1319">{achievement.name}</h3>
                    <span className="text-sm text-gray-500" data-id="element-1320">
                      {achievement.progress} / {achievement.total}
                    </span>
                  </div>
                  <p className="text-sm text-gray-600 mb-3" data-id="element-1321">
                    {achievement.description}
                  </p>
                  <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-1322">
                    <div className="bg-[#E84118] h-2 rounded-full" style={{
                width: `${achievement.progress / achievement.total * 100}%`
              }} data-id="element-1323" />
                  </div>
                </div>)}
              <div className="mt-6" data-id="element-1324">
                <h2 className="text-lg font-bold mb-4" data-id="element-1325">Badges</h2>
                <div className="grid grid-cols-3 md:grid-cols-4 gap-3" data-id="element-1326">
                  {badges.map(badge => <div key={badge.id} className={`p-3 rounded-lg text-center ${badge.unlocked ? 'bg-green-50' : 'bg-gray-50'}`} data-id="element-1327">
                      <div className="w-12 h-12 mx-auto mb-2 rounded-full bg-white flex items-center justify-center" data-id="element-1328">
                        <Star className={badge.unlocked ? 'text-[#E84118]' : 'text-gray-300'} size={18} data-id="element-1329" />
                      </div>
                      <h3 className="font-medium text-xs truncate" data-id="element-1330">
                        {badge.name}
                      </h3>
                    </div>)}
                </div>
              </div>
            </div>}
          {activeTab === 'activity' && <div data-id="element-1331">
              <h2 className="text-lg font-bold mb-4" data-id="element-1332">Recent Activity</h2>
              {stamps.length === 0 ? <div className="text-center py-8 bg-gray-50 rounded-lg" data-id="element-1333">
                  <p className="text-gray-500" data-id="element-1334">No activity yet</p>
                </div> : <div className="space-y-4" data-id="element-1335">
                  {stamps.slice(0, 5).map(stamp => <div key={stamp.id} className="flex items-center justify-between p-3 border rounded-lg hover:bg-gray-50 transition-colors" data-id="element-1336">
                      <div className="flex items-center" data-id="element-1337">
                        <div className="w-10 h-10 bg-orange-100 rounded-full flex items-center justify-center mr-3" data-id="element-1338">
                          <MapPin className="text-[#E84118]" size={16} data-id="element-1339" />
                        </div>
                        <div data-id="element-1340">
                          <div className="font-medium" data-id="element-1341">{stamp.restaurant}</div>
                          <div className="text-sm text-gray-500" data-id="element-1342">
                            {stamp.cuisine}
                          </div>
                        </div>
                      </div>
                      <div className="text-right" data-id="element-1343">
                        <div className="text-sm text-gray-500" data-id="element-1344">
                          {stamp.date.toLocaleDateString()}
                        </div>
                        <div className="text-xs text-green-600" data-id="element-1345">+50 points</div>
                      </div>
                    </div>)}
                  {stamps.length > 5 && <div className="text-center mt-4" data-id="element-1346">
                      <Button variant="outline" size="sm" data-id="element-1347">
                        View All Activity
                      </Button>
                    </div>}
                </div>}
            </div>}
          {activeTab === 'settings' && <div data-id="element-1348">
              <h2 className="text-lg font-bold mb-4" data-id="element-1349">Profile Settings</h2>
              <div className="space-y-4" data-id="element-1350">
                <div data-id="element-1351">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1352">
                    Display Name
                  </label>
                  <input type="text" value={user?.name || 'Terry Crews'} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-[#E84118] focus:border-[#E84118]" data-id="element-1353" />
                </div>
                <div data-id="element-1354">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1355">
                    Email
                  </label>
                  <input type="email" value={user?.email || 'terry@example.com'} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-[#E84118] focus:border-[#E84118]" data-id="element-1356" />
                </div>
                <div data-id="element-1357">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1358">
                    Phone Number
                  </label>
                  <input type="tel" value={user?.phone || '+1234567890'} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-[#E84118] focus:border-[#E84118]" data-id="element-1359" />
                </div>
                <div className="pt-4" data-id="element-1360">
                  <Button data-id="element-1361">
                    <Settings size={16} className="mr-2" data-id="element-1362" />
                    Save Changes
                  </Button>
                </div>
              </div>
            </div>}
        </div>
      </div>
    </div>;
};
export default Profile;